import React from 'react';
import { Link } from 'react-router-dom';
import useChangePageTitle from '../Dashboard/CustomHooks/useChangePageTitle';
import './LoggedOut.css';

const LoggedOut = ({ loginPath = '/PortalSignIn', logoutMarkerKey = 'pcPortalLoggedOut' }) => {
  useChangePageTitle('LoggedOut');
  const handleReturnToLogin = () => {
    try {
      sessionStorage.removeItem(logoutMarkerKey);
      localStorage.removeItem(logoutMarkerKey);
    } catch (error) {
      // Best-effort cleanup only.
    }
  };

  return (
    <div className="loggedOutContainer">
      <div className="loggedOutCard">
        <h2 className="loggedOutHeader">You have been logged out</h2>
        <Link className="loggedOutLink" to={loginPath} onClick={handleReturnToLogin}>
          Click here if you want to log in
        </Link>
      </div>
    </div>
  );
};

export default LoggedOut;
